module.exports = __webpack_public_path__ + "static/media/647.08529364.webp";